<template>
  <div style="width: 100%">
    <h5>Inbound sms</h5>
    <m-field label="From patient">{{ patient.label }}</m-field>
    <m-field label="Message">{{ message }}</m-field>
    <m-field label="Status">{{ status }}</m-field>
    <m-field label="Received at">{{ createdAt }}</m-field>
  </div>
</template>

<script>
import MField from "../../../MField";

export default {
  components: { MField },
  props: {
    status: {
      type: String,
      default: "",
    },
    message: {
      type: String,
      default: "",
    },
    fromNumber: {
      type: String,
      default: "",
    },
    patient: {
      type: Object,
      default: null,
    },
    createdAt: {
      type: String,
      default: "",
    },
  },
};
</script>
